import _ from 'lodash';
import { RUN_GRANULARITY } from 'v2/common/constants/index';
import { getSanitizedQuantConfig } from './quantConfig/index';
import { ORDER_TYPES } from 'common/constants';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

export const beforeSubmitSanitizer = (runConfig) => {
  const {
    quant_config: quantConfig,
    run_type: runType,
    order_type: orderType,
    is_strategy_author: isStrategyAuthor,
    granularity,
  } = runConfig;

  const isSecondBySecondEnabledForUser = _.get(
    window,
    'SA_FEATURE_FLAGS.isRunGranularitySecondEnabled',
    false
  ) || window?.isAdmin;

  const getSanitizedOrderType = (orderType) => {
    if (ApplicationDomainUtility.isQubit && !ApplicationDomainUtility.isAdmin) return ORDER_TYPES.automatic.value;
    return orderType || ORDER_TYPES.automatic.value;
  };

  return {
    ...runConfig,
    order_type: getSanitizedOrderType(orderType),
    granularity: isSecondBySecondEnabledForUser
      ? granularity
      : RUN_GRANULARITY.minute,
    quant_config: JSON.stringify(
      getSanitizedQuantConfig(quantConfig, runType, orderType, isStrategyAuthor)
    ),
  };
};
